import React from "react";
import { fireEvent, render, screen } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FullPageChatLayout } from "./FullPageChatLayout";

// ChatMessage from the shared package pulls in heavy context; the notice is
// rendered by the layout around it, so a stub is enough.
jest.mock("@metalmind-ab/mmagent-chat-ui", () => ({
  ChatMessage: ({ message }: { message: { content?: string } }) => (
    <div data-testid={`chat-message-${message.content}`}>{message.content}</div>
  ),
  JobProgressIndicator: () => null,
  useChatStore: (selector: (state: any) => any) =>
    selector({
      backgroundJobs: [],
      removeBackgroundJob: jest.fn(),
      messages: [],
    }),
}));

beforeAll(() => {
  Object.defineProperty(HTMLElement.prototype, "scrollIntoView", {
    configurable: true,
    value: jest.fn(),
  });
});

it("shows Cancelling and prevents a duplicate Stop while acknowledgement is pending", () => {
  const stop = jest.fn();
  const onQueueMessage = jest.fn().mockResolvedValue(undefined);
  const props = {
    messages: [],
    onSendMessage: jest.fn(),
    onQueueMessage,
    isLoading: true,
    conversations: [],
    onLoadConversation: jest.fn(),
    onNewConversation: jest.fn(),
    onSearchConversations: jest.fn(),
    onLoadMoreConversations: jest.fn(),
    conversationsLoading: false,
    currentConversationId: 7,
    onCancelStream: stop,
  };
  const { rerender } = render(
    <FullPageChatLayout {...props} isStopping={false} />,
  );
  fireEvent.click(screen.getByRole("button", { name: "Stop generating" }));
  expect(stop).toHaveBeenCalledTimes(1);
  rerender(<FullPageChatLayout {...props} isStopping={true} />);
  const cancelling = screen.getByRole("button", { name: "Cancelling" });
  expect(cancelling).toBeDisabled();
  fireEvent.click(cancelling);
  fireEvent.keyDown(window, { key: "Escape" });
  expect(stop).toHaveBeenCalledTimes(1);
  const textbox = screen.getByRole("textbox");
  expect(textbox).toBeEnabled();
  fireEvent.change(textbox, { target: { value: "queue while cancelling" } });
  fireEvent.click(screen.getByRole("button", { name: "Queue message" }));
  expect(onQueueMessage).toHaveBeenCalledWith("queue while cancelling", []);
  expect(props.onSendMessage).not.toHaveBeenCalled();
  rerender(
    <FullPageChatLayout {...props} isLoading={false} isStopping={false} />,
  );
  expect(
    screen.queryByRole("button", { name: "Cancelling" }),
  ).not.toBeInTheDocument();
  expect(screen.getByRole("textbox")).not.toBeDisabled();
});

it("does not show an unconfirmed-save notice for visible live transcript messages", () => {
  render(
    <FullPageChatLayout
      messages={[]}
      onSendMessage={jest.fn()}
      isLoading={false}
      conversations={[]}
      onLoadConversation={jest.fn()}
      onNewConversation={jest.fn()}
      onSearchConversations={jest.fn()}
      onLoadMoreConversations={jest.fn()}
      conversationsLoading={false}
      currentConversationId={7}
    />,
  );

  expect(
    screen.queryByText(/server has not confirmed saving/i),
  ).not.toBeInTheDocument();
  expect(
    screen.queryByText(/copy the text before leaving/i),
  ).not.toBeInTheDocument();
});
